
const SHARE_TYPE = Object.freeze({
  GIFT: 'Gift',
  RECOMMEND: 'Recommend',
  SELL: 'Sell',
  SHARE: 'Share',
  WATCH_WITH_ME: 'Watch with me'
})

export { SHARE_TYPE }
